import { render, staticRenderFns } from "./Wameicamp.vue?vue&type=template&id=2b555f56"
import script from "./Wameicamp.vue?vue&type=script&lang=js"
export * from "./Wameicamp.vue?vue&type=script&lang=js"
import style0 from "./Wameicamp.vue?vue&type=style&index=0&id=2b555f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports